// extracted by mini-css-extract-plugin
export default {"SearchResItem":"SearchResItem_SearchResItem__7S8hn"};